export const IS_DEV_MODE_ENABLED = false;
export const EXTRA_IMAGES_ON_EACH_SIDE_COUNT = 0;
export const INITIAL_ZOOM_SPACING = 80;
export const INITIAL_ZOOM_SPACING_PERCENTAGE = 12;
export const PRELOAD_OTHER_LEVELS_TILES = false;
export const DOUBLE_BUFFERING_ENABLED = false;
export const RENDER_OTHER_LEVEL_TILES = false;
export const RENDER_NEXT_LEVEL_TILES = false;
export const RENDER_PREV_LEVEL_TILES = false;
export const LOADING_QUEUE_LIMIT = 5000;
export const MAX_IMAGES_PER_FRAME_IDLE = 120;
export const MAX_IMAGES_PER_FRAME_WHILE_ANIM = 7;
export const USE_UNSCALED_VISIBLE_TILES = false;
export const DISABLE_DRAW_TILES = false;
export const IS_FORCE_DPR = false;
export const FORCE_DPR_VALUE = 3;
export const MAX_ZOOM_PERCENTAGE = 150;
export const SHADOWS_FIGURE_INSET = 5;
export const USE_DPR_DEFAULT_VALUE = true;
export const SHADOWS_CTX_SIZE_MULTIPLIER = 3;
export const ZOOM_ANIM_TIME = 500;
export const MOVE_ANIM_TIME = 500;
export const ZOOM_AMOUNT_MULTIPLIER = 1.25;
export const TOUCH_ZOOM_AMOUNT = 3;
export const MOVE_SPEED_MULTIPLIER = 1.0;
export const PREVENT_IMAGE_PLACEMENT_BESIDE_BOUNDARIES = true;
export const UPDATE_POINTER_POSITION_WHILE_SCROLL_ZOOMING = false;
export const SET_CLOSEST_AVAILABLE_MOVEMENT_POSITION = true;
export const CENTER_LOCK_UNSCALED = true;
export const ALLOW_ANY_MOVEMENT_WITHOUT_BOUNDARIES = true;
export const INCREASE_MAX_ZOOM_REGARDLESS_OF_DPR = true;
export const INERTNESS_MOVE_DISTANCE_MULTIPLIER = 20;
export const INERTNESS_MOVE_MAX_DISTANCE = 1000;
export const INERTNESS_MAX_AWAIT_TIME = 100;
export const IMAGE_EXTENSION = 'webp';
export const PER_LEVELS_MULTIPLIER = 2;
export const TILE_SIZE = [256, 256];
